import React from "react";
import { formatDateTime } from './helpers';

/**
 * Transforms a single scanner website item for table display
 * @param {Object} website - Scanner website object from API
 * @param {Function} onEdit - Edit handler function
 * @returns {Object} Transformed scanner website object
 */
export const transformScannerWebsiteItem = (website, onEdit) => ({
    id: website.id,
    name: website.name,
    contacts: website.contacts,
    help: website.help,
    website: website.website,
    position: website.position,
    icon: website.icon ? (
        <img src={website.icon} alt="icon" style={{ width: '40px', height: '40px' }} />
    ) : '',
    is_active: website.is_active ? "Active" : "Inactive",
    created_at: formatDateTime(website.created_at),
    action: (
        <button
            className="btn btn-primary"
            onClick={() => onEdit(website.id, website.name, website.icon, website.is_active, website.contacts, website.help, website.website, website.position, website.created_at)}
        >
            Edit
        </button>
    )
});

/**
 * Transforms array of scanner websites into DataTable format
 * @param {Array} websites - Array of scanner website objects from API
 * @param {Array} columns - Table column configuration
 * @param {Function} onEdit - Edit handler function
 * @returns {Object} DataTable formatted object with columns and rows
 */
export const transformScannerWebsitesToTableData = (websites, columns, onEdit) => {
    const rows = websites.map(website => transformScannerWebsiteItem(website, onEdit));

    return {
        columns,
        rows
    };
};

